/**
 * Arama önerileri yerleştirici.
 *
 * "Arama önerileri" bölümü katman (overlay) grubunda gizli bir kaynak olarak render edilir.
 * Bu script içeriği, sayfadaki hedeflere kopyalar:
 *  - header arama çekmecesi  -> [data-search-suggestions-target="drawer"]
 *  - arama sayfası           -> [data-search-suggestions-target="page"]
 *
 * Bölüm doğrudan bir şablona eklenmişse (.search-suggestions--inline) sayfa hedefi atlanır.
 */
(function () {
  if (window.searchSuggestionsInitialized) {
    return;
  }
  window.searchSuggestionsInitialized = true;

  const SOURCE_SELECTOR = '[data-search-suggestions-source]';
  const TARGET_SELECTOR = '[data-search-suggestions-target]';

  function getSource() {
    return document.querySelector(SOURCE_SELECTOR);
  }

  function fillTarget(target, source) {
    const type = target.getAttribute('data-search-suggestions-target');

    // Bölüm sayfaya doğrudan eklendiyse aynı içeriği iki kez göstermeyelim.
    if (type === 'page' && document.querySelector('.search-suggestions--inline')) {
      target.hidden = true;
      return;
    }

    if (!source) {
      target.hidden = true;
      target.innerHTML = '';
      return;
    }

    target.innerHTML = source.innerHTML;

    const wrapper = target.querySelector('.search-suggestions');
    if (wrapper) {
      wrapper.classList.add('search-suggestions--' + type);
    }

    target.hidden = false;

    // Yeni eklenen ürün kartlarının hızlı sepet tetikleyicilerini bağla.
    document.querySelector('quick-cart-drawer')?.initTriggers();
  }

  function render() {
    const source = getSource();
    const targets = document.querySelectorAll(TARGET_SELECTOR);

    targets.forEach(target => fillTarget(target, source));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Tema editöründe bölüm güncellendiğinde kopyaları tazele.
  document.addEventListener('shopify:section:load', event => {
    const section = event.target;
    const touchesSuggestions =
      section.querySelector?.(SOURCE_SELECTOR) || section.querySelector?.(TARGET_SELECTOR);

    if (touchesSuggestions) {
      render();
    }
  });

  document.addEventListener('shopify:block:select', openDrawerForEditor);
  document.addEventListener('shopify:section:select', openDrawerForEditor);

  // Editörde bölüm/blok seçildiğinde arama çekmecesini aç ki merchant içeriği görebilsin.
  function openDrawerForEditor(event) {
    const isSuggestions =
      event.target.matches?.(SOURCE_SELECTOR) ||
      event.target.closest?.(SOURCE_SELECTOR) ||
      event.target.querySelector?.(SOURCE_SELECTOR);

    if (!isSuggestions) {
      return;
    }

    const drawerTarget = document.querySelector('[data-search-suggestions-target="drawer"]');
    const searchDrawer = drawerTarget?.closest('search-drawer');
    const details = searchDrawer?.querySelector('details');

    if (!searchDrawer || !details || details.hasAttribute('open')) {
      return;
    }

    searchDrawer.toggleDrawer?.();
  }
})();
